import { OfferApiDetail } from "components/other/OfferDetail/OfferApiDetail.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { useUser } from "hooks/useUser.ts";
import { PermissionEnum, RoleEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getOfferDetailHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/offer/_layout/detail/$offerId/_layout/api/"
)({
    component: OfferApiDetailPage,
    staticData: {
        permissions: [PermissionEnum.OfferApiView],
        showInSideMenu: false,
        label: "pages.offer.detail.api.title",
    },
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.offer.detail.api.title"),
    }),
});

function OfferApiDetailPage() {
    const userUtils = useUser();
    const { offerId } = Route.useParams();

    return (
        <TenantPage
            headerNavigationItems={getOfferDetailHeaderItems}
            editLink={
                userUtils
                    ?.getActiveTenant()
                    ?.userRoles?.some((role) => [RoleEnum.AdminFree, RoleEnum.AdminBeast].includes(role.name))
                    ? {
                          to: "/offer/edit/$offerId/api",
                          params: { offerId: offerId },
                      }
                    : null
            }
        >
            <OfferApiDetail key={offerId} offerId={offerId} />
        </TenantPage>
    );
}
